<div class="container">
    <div class="parks-container">
        <finder-calendar-park
            *ngFor="let location of locations"
            [labels]="data.labels"
            [icons]="data.icons"
            [date]="formattedDate"
            [location]="location"
            [isClosedFacilitiesExpanded]="data?.expandClosedFacilities">
        </finder-calendar-park>
    </div>
</div>
